// Project a lat/lng onto viewport pixels using the map's own mercator
// projection.
//
// Exists so a popover can be portalled out of the map and still stay glued to
// its marker: a deck.gl canvas in the float pane paints over AdvancedMarkers
// whatever their zIndex, so anything that must sit above the markers has to
// leave the map's DOM and be positioned by hand.
export type ViewportPoint = {
  x: number
  y: number
}

export const projectLatLng = (map: google.maps.Map, lat: number, lng: number): ViewportPoint | null => {
  const projection = map.getProjection?.()
  const bounds = map.getBounds?.()
  const zoom = map.getZoom?.()
  if (!projection || !bounds || zoom === undefined) return null

  const scale = 2 ** zoom
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()
  const topLeft = new google.maps.LatLng(ne.lat(), sw.lng())
  const worldTopLeft = projection.fromLatLngToPoint(topLeft)
  const worldPoint = projection.fromLatLngToPoint(new google.maps.LatLng(lat, lng))
  if (!worldTopLeft || !worldPoint) return null

  const rect = map.getDiv().getBoundingClientRect()
  return {
    x: (worldPoint.x - worldTopLeft.x) * scale + rect.left,
    y: (worldPoint.y - worldTopLeft.y) * scale + rect.top,
  }
}

export default projectLatLng
